import styled from 'styled-components';

export const Constancy = styled.div``;

export const ElementClaim = styled.button`
  padding: 2px;
  color: #5b36f2;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;

  &:focus {
    outline: 1.5px solid #5b36f2;
    border-radius: 4px;
    color: #4318cd;
  }
`;

export const Payment = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  p.status-desc {
    text-align: center;
  }

  > div:nth-of-type(1) {
    width: 100%;
    border-radius: 8px;
    background-color: #ecf4f9;

    > picture > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    @media (min-width: 768px) {
      height: 196px;
      width: 220px;
    }
  }

  > div:nth-of-type(2) {
    width: 100%;

    > button {
      width: 100%;
    }

    @media (min-width: 640px) {
      > button {
        width: max-content;
        margin-left: auto;
        margin-right: auto;
      }
    }

    @media (min-width: 768px) {
      width: calc(100% - 236px);

      > button {
        margin-left: 0;
      }
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    & p.status-desc {
      text-align: left;
    }
  }
`;
